import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import Notification from '../RetryNotification/RetryNotification.js';
import RetryPaymentLoader from '../RetryPaymentLoader/RetryPaymentLoader.js';
import PayPalRetryButton from '../../PayPal/PayPalRetryButton/PayPalRetryButton.js';
import { useTranslation } from '../../../hooks/useTranslations.js';
import styles from './RetryPaymentPaypal.module.scss.js';

const RetryPaymentPaypal = ({ currency, sid, customerId, amount, orderId, siteId, }) => {
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    return (jsxs("div", { className: styles.retryPaypalPayment, children: [loading && jsx(RetryPaymentLoader, {}), jsxs(Notification, { sid: sid, currency: currency, siteId: siteId, customerId: customerId, id: "retryPaymentNotification", ariaLabel: t('mzp.order.detail.retry.payment.accessibility.label'), type: "warning", children: [t('mzp.order.detail.payment.reminder.warning', {
                        0: t('mzp.order.detail.retry.payment.button', {
                            0: t('general.payment.paypal'),
                        }),
                    }), jsx("div", { className: styles.retryPaypalPaymentButtonContainer, "data-zta": "retryPaypalPaymentContainer", children: jsx(PayPalRetryButton, { currency: currency, orderId: orderId, setLoading: setLoading, amount: amount, siteId: siteId }) })] })] }));
};

export { RetryPaymentPaypal as default };
//# sourceMappingURL=RetryPaymentPaypal.js.map
